module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fullscreen-overlay-layout', {
    attrs: {
      "pageWidth": _vm.tab === 'class-wide' ? '750px' : '1200px',
      "centeredTitle": true,
      "title": _vm.getCurrentDiscussion.title
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [(_vm.hasTeacherPermissionsInCourse) ? _c('div', [_c('pl-button', {
    class: _vm.getBtnClass('class-wide'),
    staticStyle: {
      "color": "black"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 'class-wide'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/live_discussion/polls.svg",
      "alt": "",
      "height": "18px",
      "width": "22px"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Class-wide ")])]), _vm._v(" "), _c('pl-button', {
    class: _vm.getBtnClass('individual'),
    staticStyle: {
      "width": "130px",
      "color": "black"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 'individual'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/live_discussion/individual.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Individual ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.show_spinner) ? _c('div', {
    staticClass: "flex justify-center"
  }, [_c('pl-spinner')], 1) : [(_vm.tab === 'class-wide') ? [_c('div', [_c('participation-counter'), _vm._v(" "), _c('span', {
    staticClass: "pl-display-1"
  }, [_vm._v("Participation Rate")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vertical-line"
  }), _vm._v(" "), _c('div', [_c('pl-menu', {
    attrs: {
      "menuSize": 8,
      "direction": "right"
    }
  }, [_c('pl-button', {
    staticClass: "pl-display-1 flex flex-nowrap items-center no-padding",
    staticStyle: {
      "color": "#43484c"
    },
    attrs: {
      "slot": "menu_trigger"
    },
    slot: "menu_trigger"
  }, [_c('span', [_vm._v(_vm._s(_vm.time_spent.content))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down fa-xs pl3",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "menu-content": ""
    }
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.getTimeSpent('tapped-in', 'Time spent tapped in')
      }
    }
  }, [_c('span', {
    staticClass: "time-spent-span",
    class: {
      checkmark: _vm.time_spent.key === 'tapped-in'
    }
  }, [_vm._v("\n                Time spent tapped in\n              ")]), _vm._v(" "), (_vm.time_spent.key === 'tapped-in') ? _c('i', {
    staticClass: "fa fa-check checkmark",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.getTimeSpent('as-speaker', 'Time spent as speaker')
      }
    }
  }, [_c('span', {
    staticClass: "time-spent-span",
    class: {
      checkmark: _vm.time_spent.key === 'as-speaker'
    }
  }, [_vm._v("Time spent as speaker")]), _vm._v(" "), (_vm.time_spent.key === 'as-speaker') ? _c('i', {
    staticClass: "fa fa-check checkmark",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])])], 1), _vm._v(" "), _c('aster-plot', {
    key: _vm.componentKey,
    staticClass: "mv5",
    attrs: {
      "time_spent_key": _vm.time_spent.key
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip.bottom",
      value: (_vm.configTooltip(_vm.reflections.time_in_circle)),
      expression: "configTooltip(reflections.time_in_circle)",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "reflection-text"
  }, [_vm._v("\n          Reflection Questions\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vertical-line"
  }), _vm._v(" "), _c('div', [_c('tap-in-counter'), _vm._v(" "), _c('span', {
    staticClass: "pl-display-1"
  }, [_vm._v("Tap-ins per student")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vertical-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "row no-margin no-padding center-xs"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('div', {
    staticClass: "turn_count primary-colour"
  }, [_vm._v("\n            " + _vm._s(_vm.turn_count_by_type.new_idea || 0) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "pl-headline"
  }, [_vm._v("New Ideas")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('div', {
    staticClass: "turn_count ruby-colour"
  }, [_vm._v("\n            " + _vm._s(_vm.turn_count_by_type.challenge || 0) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "pl-headline"
  }, [_vm._v("Challenges")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('div', {
    staticClass: "turn_count green-colour"
  }, [_vm._v("\n            " + _vm._s(_vm.turn_count_by_type.build_on || 0) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "pl-headline"
  }, [_vm._v("Build Ons")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('div', {
    staticClass: "turn_count black-colour"
  }, [_vm._v("\n            " + _vm._s(_vm.turn_count_by_type.question || 0) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "pl-headline"
  }, [_vm._v("Questions")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt4 pl-title tl"
  }, _vm._l((_vm.suggestions), function(suggestion, index) {
    return _c('div', {
      staticClass: "mb4"
    }, [_c('span', {
      staticClass: "b"
    }, [_vm._v("Suggestion " + _vm._s(index + 1) + " - ")]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(suggestion.text)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "why-this-suggestion ruby-colour pl-caption"
    }, [_vm._v("\n            Why this suggestion?\n            "), _c('span', {
      staticClass: "suggestion-tooltip pl-caption"
    }, [_vm._v(_vm._s(suggestion.explanation))])])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip.bottom",
      value: (_vm.configTooltip(_vm.reflections.total_tap_ins)),
      expression: "configTooltip(reflections.total_tap_ins)",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "reflection-text"
  }, [_vm._v("\n        Reflection Questions\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "vertical-line"
  }), _vm._v(" "), _c('div', {
    class: [_vm.show_full_tap_in_summary ? 'expanded' : 'collapsed']
  }, [_c('span', {
    staticClass: "pl-display-1"
  }, [_vm._v("Tap-In Summary")]), _vm._v(" "), _c('horizontal-stacked-bar', {
    staticClass: "mt3"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mb4"
  }, [_c('p', {
    staticClass: "pl-title expand-btn",
    on: {
      "click": function($event) {
        _vm.show_full_tap_in_summary = !_vm.show_full_tap_in_summary
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.show_full_tap_in_summary ? 'Hide' : 'Expand All') + "\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip.bottom",
      value: (_vm.configTooltip(_vm.reflections.bar_chart)),
      expression: "configTooltip(reflections.bar_chart)",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "reflection-text mb6"
  }, [_vm._v("\n        Reflection Questions\n      ")])] : [_c('individual-summary-overlay', {
    attrs: {
      "table_data": _vm.table_data
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  })]]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6ee942af!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/measureLiveDiscussion/classSummaryOverlay.vue
// module id = 1731
// module chunks = 61